import { get, writable } from 'svelte/store';
import { SvelteComponent } from 'svelte';

import iconSettings from '../lib/shared/Icons/svg/official/settings_FILL0_wght400_GRAD0_opsz24.svg';
import iconWarehouses from '../lib/shared/Icons/svg/official/Magazyny.svg';
import iconVehicles from '../lib/shared/Icons/svg/official/Pojazdy.svg';
import iconMaps from '../lib/shared/Icons/svg/map_FILL0_wght400_GRAD0_opsz24.svg';
import iconPlanning from '../lib/shared/Icons/svg/official/Planowanie.svg';
import iconImports from '../lib/shared/Icons/svg/official/Import.svg';
import iconAlarm from '../lib/shared/Icons/svg/alarm_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconBarChart from '../lib/shared/Icons/svg/bar_chart_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import iconJobs from '../lib/shared/Icons/svg/official/Zlecenia.svg';
import iconTactic from '../lib/shared/Icons/svg/official/Plany.svg';
import iconToolsPowerDrill from '../lib/shared/Icons/svg/tools_power_drill_FILL0_wght400_GRAD0_opsz24.svg';
import iconDashboardCustomize from '../lib/shared/Icons/svg/official/Panele.svg';
import iconAccounts from '../lib/shared/Icons/svg/person_FILL0_wght400_GRAD0_opsz24.svg';
import iconHexagon from '../lib/shared/Icons/svg/hexagon_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
import PageSettings from '../lib/components/Settings/PageSettings.svelte';
import PageUploadFile from '../lib/components/Import/PageUploadFile.svelte';
import PageAssignColumns1141 from '../lib/components/ColumnSelectPro/PageAssignColumns.svelte';
import PageVehicles from '../lib/components/Vehicles/PageVehicles.svelte';
import PageOrders from '../lib/components/Jobs/PageJobs.svelte';
import PagePlanning from '../lib/components/Planning/PageScenario/PagePlanning.svelte';
import PageZones from '../lib/components/Zones/PageZones.svelte';
import PageMaps from '../lib/components/Maps/PageMaps.svelte';
import PageWarehouses from '../lib/components/Warehouses/PageWarehouses.svelte';
import PageImports from '../lib/components/Import/PageImports.svelte';
import PageTacticalPlan from '../lib/components/TacticalPlan/PageTacticalPlan.svelte';
import PageTacticalPlanOne from '../lib/components/TacticalPlan/PageTacticalPlanOne.svelte';
import { AssignmentManager } from '../lib/components/Planning/PageScenario/AssignmentManager';
import type { JobResponseType } from '../lib/components/Jobs/types';
import type { TacticalPlanRule } from '../lib/components/TacticalPlan/TacticalPlanRule';
import PageWorkshop from '../lib/components/Workshop/PageWorkshop.svelte';
import { createCurrentZoneListStore } from '../lib/components/TacticalPlan/CurrentZoneListStore';
import PageGeocoding from '../lib/components/Import/PageGeocoding.svelte';
import type {
    QuickCategoriesIdEmptyType,
    QuickCategoriesIdType,
} from '../lib/components/Planning/QuickCategories/QuickCategoriesConfig';
import PageManualAddJob from '../lib/components/Jobs/PageManualAddJob.svelte';
import { type QueriesType } from '../lib/components/telematics/types';
import PageDashboard from '../lib/shared/Dashboard/PageDashboard.svelte';
import { Assignment } from '../lib/components/Planning/Assignment';
import type ToggleRouteLockIcon from '../lib/components/Planning/ToggleRouteLockIcon.svelte';
import PageDeliveryListRouter from '../lib/components/Planning/PageDeliveryListRouter.svelte';
import { MenuContextFactory } from '../lib/components/MenuDropdown/MenuContext/MenuContextFactory';
import PageAccounts from '../lib/components/Accounts/PageAccounts.svelte';
import { app } from './app';
import PageImportAnalyze from '../lib/components/Import/PageImportAnalyze.svelte';
import PageAdmin from '../lib/components/Admin/PageAdmin.svelte';
import PageGantt from '../lib/components/GanttCouriers/PageGantt.svelte';
import PageEasyVrp from '../lib/components/EasyVrp/PageEasyVrp.svelte';
import type { QuickFilterType } from '../lib/shared/QuickFilter.svelte';
import type { MenuNotificationType } from '../lib/shared/Menu/MainMenuNotification.svelte';
import PageJobModifyTimeWindowRule from '../lib/components/JobModifyTimeWindowRule/PageJobModifyTimeWindowRule.svelte';

export const scenarioManager = writable<AssignmentManager>(new AssignmentManager());

export const defaultPageLink = '/';

// export const showUnassignedDeliveries = writable(false);

// debug only when host is in localhost
export const debug = writable(false);
export const featureTogglerVisible = writable(false);

export const accountName = writable<string>('...');
export let tacticalPlanName = writable<string>('');
export let tacticalPlanRuleCurrent = writable<string | null>(null);

export const currentZoneList = createCurrentZoneListStore();

export let lastClickedPosition = writable<{ x: number; y: number }>({ x: 0, y: 0 });
lastClickedPosition.subscribe(value => {
    // console.log('lastClickedPosition', value);
    MenuContextFactory.setCoords(value.x, value.y);
});

export let readonlyMode = writable<boolean>(false);

export let disableRefreshing = writable<boolean>(false);

export type TacticalPlanStoreType = {
    triggerStartSaveThisRuleByInnerId: string;
    saveResult: {
        success: boolean;
        message: string;
    };
    triggerZonesSave: boolean;
    countedErrors: number;
    ruleToCopy: TacticalPlanRule | null;
    forceReload: boolean;
    volume: {
        dateRange: number[];
        type: string;
        average: boolean;
        strictDates: boolean;
    };
};

export let tacticalPlanStore = writable<TacticalPlanStoreType>({
    triggerStartSaveThisRuleByInnerId: '',
    saveResult: {
        success: false,
        message: '',
    },
    triggerZonesSave: false,
    countedErrors: 0,
    ruleToCopy: null,
    forceReload: false,
    volume: {
        dateRange: [-2, 1],
        type: 'parcels',
        average: true,
        strictDates: false
    }
});

//
// // change debug value to true if host is localhost
// if (window.location.hostname === 'localhost') {
//     debug.set(true);
// }

// change debug value on Ctrl+1
if (typeof document !== 'undefined') {
    document.addEventListener('keydown', event => {
        // Ctrl + F1
        if (event.ctrlKey && event.shiftKey && event.altKey && event.key === 'F1') {
            if (get(readonlyMode)) {
                console.warn('Readonly mode is enabled');
                return;
            }
            debug.set(!get(debug));
            console.log('Ctrl+Alt+Shift+F1', get(debug));
            event.preventDefault();
        }
        // Ctrl + F2
        if (event.ctrlKey && event.shiftKey && event.altKey && event.key === 'F2') {
            if (get(readonlyMode)) {
                console.warn('Readonly mode is enabled');
                return;
            }
            featureTogglerVisible.set(!get(featureTogglerVisible));
            console.log('Ctrl+Alt+Shift+F2', get(featureTogglerVisible));
        }
    });
}

export type MainMenuItemType = {
    id: string;
    component: new (...args: any[]) => SvelteComponent;
    to: string;
    icon: string;
    label: string;
    visible: boolean;
    visibleInMenu: boolean;
    side: string;
    notification?: MenuNotificationType;
};

export type MainMenuType = {
    currentPage: string;
    expanded: boolean;
    fullscreenMode: false;
    items: MainMenuItemType[];
    autoShowNotification: boolean;
};

export const mainMenu = writable<MainMenuType>({
    currentPage: 'PageVehicles',
    expanded:
        typeof localStorage !== 'undefined'
            ? localStorage.getItem('mainMenuExpanded') === 'true'
            : false,
    fullscreenMode: false,
    items: [
        // {
        //     id: 'PageStart',
        //     component: PageStart,
        //     to: '/start',
        //     icon: iconFlag,
        //     label: 'Start',
        //     visible: true,
        //     visibleInMenu: true,
        //     side: 'left',
        // },
        {
            id: 'PageUploadFile',
            component: PageUploadFile,
            to: '/upload-file',
            icon: '',
            label: 'Upload file',
            visible: true,
            visibleInMenu: false,
            side: 'both',
        },
        {
            id: 'PageGeocoding',
            component: PageGeocoding,
            to: '/geocoding',
            icon: '',
            label: '',
            visible: false,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageManualAddJob',
            component: PageManualAddJob,
            to: '/manual-add-job',
            icon: '',
            label: '',
            visible: false,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageEditJob',
            component: PageManualAddJob,
            to: '/edit-job/:id',
            icon: '',
            label: '',
            visible: true,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageAssignColumns',
            component: PageAssignColumns1141,
            to: '/assign-columns',
            icon: '',
            label: 'Assign columns',
            visible: true,
            visibleInMenu: false,
            side: 'both',
        },
        {
            id: 'PageOrdersToBeCompleted',
            component: PageOrders,
            to: defaultPageLink, //orders-to-be-completed',
            icon: iconJobs,
            label: 'Orders',
            visible: true,
            visibleInMenu: true,
            side: 'left',
            notification: {
                reload: true,
            },
        },
        {
            id: 'PageJobModifyTimeWindowRule',
            component: PageJobModifyTimeWindowRule,
            to: '/job-modify-time-window-rule',
            icon: iconAlarm,
            label: 'time_window_rules',
            visible: true,
            visibleInMenu: true,
            side: 'right',
            notification: {
                reload: true,
            },
        },
        {
            id: 'PageTacticalPlan',
            component: PageTacticalPlan,
            to: '/tactical-plan',
            icon: iconTactic,
            label: 'Tactical plans',
            visible: true,
            visibleInMenu: true,
            side: 'right',
            notification: {
                reload: true,
            },
        },
        {
            id: 'PageTacticalPlanOne',
            component: PageTacticalPlanOne,
            to: '/tactical-plan/:id',
            icon: iconTactic,
            label: 'Tactical plans',
            visible: true,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PagePlanning',
            component: PagePlanning,
            to: '/planning',
            icon: iconPlanning,
            label: 'Planning',
            visible: true,
            visibleInMenu: true,
            side: 'left',
            notification: {
                reload: true,
            },
        },
        {
            id: 'PageDeliveryList',
            component: PageDeliveryListRouter,
            to: '/planning/:id',
            icon: iconPlanning,
            label: 'Planning',
            visible: true,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageImports',
            component: PageImports,
            to: '/imports',
            icon: iconImports,
            label: 'Imports',
            visible: true,
            visibleInMenu: true,
            side: 'left',
        },
        // {
        //     id: 'PageInProgress',
        //     component: PageInProgress,
        //     to: '/in-progress',
        //     icon: iconInProgress,
        //     label: 'In progress',
        //     visible: true,
        //     visibleInMenu: true,
        //     side: "left"
        // },
        {
            id: 'PageGanttCouriers',
            component: PageGantt,
            to: '/gantt-couriers',
            icon: iconBarChart,
            label: 'Gantt couriers',
            visible: false,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageEasyVrp',
            component: PageEasyVrp,
            to: '/easy-vrp',
            icon: iconHexagon,
            label: 'Easy VRP',
            visible: false,
            visibleInMenu: false,
            side: 'left',
        },
        {
            id: 'PageImportAnalyze',
            component: PageImportAnalyze,
            to: '/import-analyze',
            icon: '',
            label: 'Import analyze',
            visible: true,
            visibleInMenu: false,
            side: 'both',
        },
        // {
        //     id: 'PageOrdersInProgress',
        //     component: PageOrders,
        //     icon: '',
        //     label: 'In progress',
        //     visible: true,
        //     side: "left"
        // },
        // {
        //     id: 'PageOrdersFinished',
        //     component: PageOrders,
        //     icon: '',
        //     label: 'Orders finished',
        //     visible: false,
        //     side: "left"
        // },
        {
            id: 'PageZones',
            component: PageZones,
            to: '/map/:id',
            icon: iconMaps,
            label: 'Zones',
            visible: true,
            visibleInMenu: false,
            side: 'right',
        },
        {
            id: 'PageMaps',
            component: PageMaps,
            to: '/map',
            icon: iconMaps,
            label: 'Maps',
            visible: true,
            visibleInMenu: false,
            side: 'right',
        },
        {
            id: 'PageVehicles',
            component: PageVehicles,
            to: '/vehicles',
            icon: iconVehicles,
            label: 'Vehicles',
            visible: true,
            visibleInMenu: true,
            side: 'right',
            notification: {
                reload: true,
            },
        },
        {
            id: 'PageWarehouses',
            component: PageWarehouses,
            to: '/warehouses',
            icon: iconWarehouses,
            label: 'Warehouses',
            visible: true,
            visibleInMenu: true,
            side: 'right',
            notification: {
                reload: true,
            },
        },
        {
            id: 'PageDashboard',
            component: PageDashboard,
            to: '/dashboard',
            icon: iconDashboardCustomize,
            label: 'Dashboard',
            visible: true,
            visibleInMenu: true,
            side: 'right',
        },
        {
            id: 'PageSettings',
            component: PageSettings,
            to: '/settings',
            icon: iconSettings,
            label: 'Settings',
            visible: true,
            visibleInMenu: true,
            side: 'right',
        },
        {
            id: 'PageWorkshop',
            component: PageWorkshop,
            to: '/workshop',
            icon: iconToolsPowerDrill,
            label: '# WORKSHOP #',
            visible: false,
            visibleInMenu: false,
            side: 'right',
        },
        {
            id: 'PageAdmin',
            component: PageAdmin,
            to: '/admin',
            icon: iconAccounts,
            label: 'Administration',
            visible: false,
            visibleInMenu: false,
            side: 'right',
        },
        {
            id: 'PageAccounts',
            component: PageAccounts,
            to: '/accounts',
            icon: iconAccounts,
            label: 'Accounts',
            visible: false,
            visibleInMenu: false,
            side: 'right',
        },
    ],
    autoShowNotification: true,
});

mainMenu.subscribe(value => {
    if (typeof localStorage !== 'undefined') {
        localStorage.setItem('mainMenuExpanded', value.expanded ? 'true' : 'false');
    }
});

export const pagesAvailableInPlanningMode = [
    // 'Home',
    'PageStart',
    'PagePlanning',
    'PageZones',
    // 'PageMaps',
    'PageUploadFile',
    'PageAssignColumns',
    'PageOrdersToBeCompleted',
    'ZoneList',
    'PageVehicles',
    'PageWarehouses',
    'PageSettings',
];

export const pagesAvailableInReadOnlyMode = ['PagePlanning'];

export const pagesAvailableNotInPlanningMode = [
    'PageVehicles',
    'WarehouseList',
    'ZoneList',
    'PageSettings',
];

// export const onMapLoaded = writable(false);
export const isMapLoaded = writable(false);

// export const simpleView = writable(
//     typeof localStorage !== 'undefined'
//             ? localStorage.getItem('simpleView') === 'true'
//             : true
// );
//
// simpleView.subscribe(value => {
//     if (typeof localStorage !== 'undefined') {
//         localStorage.setItem('simpleView', value ? 'true' : 'false');
//     }
// });

export type PlanningType = {
    adHocMode: boolean;
    adHocModeEnabled: boolean;
    // visibleRoutesTrigger: boolean,
    setRouteEnableTime: boolean;
    selectedRouteEnableDate: string;
    selectedRouteEnableTime: string;
    currentScenarioId: number | null;
    scenarioToCompare: {
        enabled: boolean;
        scenarioId: number | null;
        tacticalPlanId: number | null;
        calculatingInProgress: boolean;
    };
    planningStarted: boolean;
    assignments: number;
    selectedDay: string;
    // countRoutesToCalculate: number,
    // routesToLock: number[],
    routingProgress: number | null;
    forceReload: boolean;
    // showUnassignedDeliveries: boolean;
    // showSuggestedDeliveries: boolean;
    selectedAssignments: number[];
    currentQuickCategoryId: QuickCategoriesIdType | QuickCategoriesIdEmptyType;
    quickCategoryHideMethod: 'hide' | 'opacity';
    forceToSetTacticalPlan: boolean;
    currentAssignmentLockToggleIcon: ToggleRouteLockIcon | null;
    lastUsedAssignment: Assignment | null;
    daysWithJobsToProcess: Record<string, number>; // date (YYYY-MM-DD) -> count of jobs to process on this day
    // backFromSubpage: boolean
};

export const planning = writable<PlanningType>({
    adHocMode: false,
    adHocModeEnabled: false,
    // visibleRoutesTrigger: false,
    setRouteEnableTime: true,
    selectedRouteEnableDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000)
        .toISOString()
        .substring(0, 10),
    selectedRouteEnableTime: '20:00',
    currentScenarioId: null,
    scenarioToCompare: {
        enabled: false,
        scenarioId: null,
        tacticalPlanId: null,
        calculatingInProgress: false,
    },
    planningStarted: false,
    assignments: 0,
    selectedDay: new Date(Date.now() - new Date().getTimezoneOffset() * 60 * 1000)
        .toISOString()
        .substring(0, 10), // this day will be replaced in App.svelte on load user settings
    // countRoutesToCalculate: 0,
    // routesToLock: [],
    routingProgress: null,
    forceReload: false,
    // showUnassignedDeliveries: true,
    // showSuggestedDeliveries: true,
    selectedAssignments: [],
    currentQuickCategoryId: '',
    quickCategoryHideMethod: 'opacity',
    forceToSetTacticalPlan: false,
    currentAssignmentLockToggleIcon: null,
    lastUsedAssignment: null,
    // backFromSubpage: false
});

export type DeliverListType = {
    selectMode: 'filtered' | 'selected';
    selectedOrUnselected: number[];
    query: QueriesType;
    queryFilter: QueriesType;
    // currentAssignmentId: number|null,
    currentAssignment: null | Assignment;
    countFiltered: { count: number };
    countAssignedFiltered: { count: number };
    countSuggestedFiltered: { count: number };
    triggerReload: boolean;
    displayedAssignmentJobDetails: {
        jobId: number;
        hasAssignment: boolean;
        hasSuggestion: boolean;
        hasAdhoc: boolean;
        canBeRejected: boolean;
        canBeAssigned: boolean;
    }[];
    allJobIds: number[];
    isRouteVariantVisible: boolean;
    filterHidden: boolean;
    expandedIndex: number[]; // jobId[]
};

export const deliveryList = writable<DeliverListType>({
    selectMode: 'selected',
    selectedOrUnselected: [],
    query: {},
    queryFilter: {},
    // currentAssignmentId: null,
    currentAssignment: null,
    countFiltered: { count: 0 },
    countAssignedFiltered: { count: 0 },
    countSuggestedFiltered: { count: 0 },
    triggerReload: false,
    displayedAssignmentJobDetails: [],
    allJobIds: [],
    isRouteVariantVisible: false,
    filterHidden: false,
    expandedIndex: [], // jobId
});

/*
{
  "x": 20.933074951171875,
  "y": 52.40283780245278,
  "quality": 0,
  "countryCodes": {
    "iso2": "PL",
    "iso3": "POL",
    "targeo": "PL"
  },
  "country": "PL",
  "province": "mazowieckie",
  "district": "legionowski",
  "community": "Legionowo",
  "city": "Legionowo",
  "quarter": "",
  "postcode": "",
  "street": "Sienkiewicza Henryka",
  "house": "33",
  "mapLink": "https://mapa.targeo.pl/20.933074951172,52.402837802453,23"
}
 */

export type RevGeoDetailsType = {
    x: number;
    y: number;
    quality: number;
    countryCodes: {
        iso2: string;
        iso3: string;
        targeo: string;
    };
    country: string;
    province: string;
    district: string;
    community: string;
    city: string;
    quarter: string;
    postcode: string;
    street: string;
    house: string;
    mapLink: string;
};

export type JobType = {
    selectedOrUnselected: number[];
    // selectAllChecked: boolean,
    selectMode: 'filtered' | 'selected';
    filteredJobs: JobResponseType[];
    defaultTargetDate: string;
    countFiltered: { count: number };
    countTotal: { count: number };
    forceRecount: boolean;
    forceReload: boolean;
    revGeoDetails: RevGeoDetailsType | null;
    showHistory: boolean;
    showOnlyToDo: boolean;
    quickFilters: {
        filters: QuickFilterType[];
        counts: ({ count: number } | null)[];
    };
};

export const jobs = writable<JobType>({
    selectedOrUnselected: [],
    // selectAllChecked: false,
    selectMode: 'selected',
    filteredJobs: [],
    countFiltered: { count: 0 },
    countTotal: { count: 0 },
    defaultTargetDate: new Date(
        Date.now() - new Date().getTimezoneOffset() * 60 * 1000 + 1000 * 60 * 60 * 24
    )
        .toISOString()
        .substring(0, 10),
    forceRecount: false,
    forceReload: false,
    revGeoDetails: null,
    showHistory: false,
    showOnlyToDo: true, //https://er.automapa.pl/issues/42840
    quickFilters: {
        filters: [],
        counts: [],
    },
});

export let leftPageWidthPx = writable<number>(0);
